import { render, staticRenderFns } from "./consents.vue?vue&type=template&id=209d6e32"
import script from "./consents.vue?vue&type=script&lang=ts"
export * from "./consents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports